import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { memo } from 'react';
import { VaultV2TimelockedFunctionName } from '@/types/enums';
import type { VaultV2Caps, VaultV2PendingTimelockDecodedData } from '../../types/pendingTimelocks';
import VaultV2PendingTimelockChangeAbsoluteCap from './VaultV2PendingTimelockChangeAbsoluteCap';
import VaultV2PendingTimelockChangeRelativeCap from './VaultV2PendingTimelockChangeRelativeCap';
type VaultV2AdapterPendingData = Extract<VaultV2PendingTimelockDecodedData, {
  __typename: 'VaultV2IncreaseCapPendingData';
}>;
interface VaultV2PendingTimelockChangeCapProps {
  functionName: string;
  decodedData: VaultV2AdapterPendingData;
  caps?: VaultV2Caps;
  vaultSupplyToken?: InterfaceToken | null;
}
const VaultV2PendingTimelockChangeCap = t0 => {
  const $ = _c(15);
  const {
    functionName,
    decodedData,
    caps: t1,
    vaultSupplyToken
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const caps = t2;
  if (functionName === VaultV2TimelockedFunctionName.IncreaseRelativeCap) {
    let t3;
    if ($[2] !== caps || $[3] !== decodedData.cap || $[4] !== decodedData.config.data || $[5] !== decodedData.config.id || $[6] !== functionName) {
      t3 = <VaultV2PendingTimelockChangeRelativeCap newValue={decodedData.cap} functionName={functionName} capId={decodedData.config.id} caps={caps} data={decodedData.config.data} />;
      $[2] = caps;
      $[3] = decodedData.cap;
      $[4] = decodedData.config.data;
      $[5] = decodedData.config.id;
      $[6] = functionName;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  if (functionName === VaultV2TimelockedFunctionName.IncreaseAbsoluteCap) {
    let t3;
    if ($[8] !== caps || $[9] !== decodedData.cap || $[10] !== decodedData.config.data || $[11] !== decodedData.config.id || $[12] !== functionName || $[13] !== vaultSupplyToken) {
      t3 = <VaultV2PendingTimelockChangeAbsoluteCap newValue={decodedData.cap} functionName={functionName} capId={decodedData.config.id} caps={caps} data={decodedData.config.data} vaultSupplyToken={vaultSupplyToken} />;
      $[8] = caps;
      $[9] = decodedData.cap;
      $[10] = decodedData.config.data;
      $[11] = decodedData.config.id;
      $[12] = functionName;
      $[13] = vaultSupplyToken;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    return t3;
  }
  return null;
};
export default memo(VaultV2PendingTimelockChangeCap);